import callApi from './partials/api';
import store from '@/store'

export default {
    // 服務條款
    policyType(cb) {
        let companyId = store.getters['advancedSearch/companyId'];
        callApi('get', `Policy/ServiceRule/${companyId}`, cb);
    },
}
